import axios from 'axios'
import { buildQuery } from '../exports/queryStringBuilder'
import { reviewBuildQuery } from '../exports/reviewQueryStringBuilder'


export default {
    //////checkoff actions
    async selectCheckoffOrders(page,filters) {
        console.log("filters",filters)
        //   return await axios.get(`customer?q=${query}&page=${page}&${buildQuery(filters)}`)
        return await axios.get(`order/bulk/checkoffs?page=${page}&${reviewBuildQuery(filters)}`)
    },

    async bulkCheckoffOrders(payload) {
        return await axios.post(`order/bulk/checkoffs`, payload)
    },
    async updateItemOrder(payload) {
        return await axios.post(`order/update/display/order/`, payload)
    },
    //////////////////////////

    async myorders() {
        return await axios.get(`order/my_orders`)
    },

    async fetchPresigned(type, key) {
        const path = `presigned/${type}?key=${key || 0}`
        return await axios.get(path)
    },

    async create(model) {
        return await axios.post(`order`, model)
    },
    async fetchById(id) {
        return await axios.get(`order/${id}`)
    },
    async fetchStatus(id){
        return await axios.get(`order/status/${id}`)
    },
    async fetch(query, filters, page) {
        return await axios.get(
            `order?q=${query}&page=${page}&` + buildQuery(filters),{
                headers: {
                    'Content-Encoding': 'gzip',
                  }
            }
        )
    },
    async fetchSchedule(query, filters) {
        return await axios.get(
            `order/get/schedule?q=${query}&` + buildQuery(filters)
        )
    },

    async fetchDrivers() {
        return await axios.get(`user/all`)
    },
    async fetchDriversNew() {
        return await axios.get(`user/all-dropdown-list`)
    },

    async update(id, model) {
        console.log('api model', model)
        return await axios.put(`order/${id}`, model)
    },
    async customerSignoff(id, model) {
        console.log('api model', model)
        return await axios.post(`order/${id}/customer-signoff`, model)
    },
    async duplicate_order(model) {
        console.log('duplicate model', model)
        return await axios.post(`order/duplicate_order`, model)
    },
    
    async delete(id) {
        return await axios.delete(`order/${id}`)
    },
    async markAsComplete(id, address) {
        return await axios.post(`order/${id}/complete`, address)
    },
    async markAsIncomplete(id) {
        return await axios.post(`order/${id}/incomplete`)
    },
    async markAsRelease(id) {
        return await axios.post(`order/${id}/release`)
    },
    async updateTasks(orderId, tasks) {
        return await axios.post(`order/${orderId}/checklist`, {
            data: tasks,
        })
    },

    /* Order Items */
    async fetchOrderItems(orderId) {
        return await axios.get(`order/${orderId}/items`)
    },

    async updateOrderItems(orderId, { total, items }) {
        return await axios.post(`order/${orderId}/items`, { total, items })
    },

    async createOrderItem(orderId, item) {
        return await axios.post(`order/${orderId}/create_item`, item)
    },

    async updateOrderItem(orderId, id, item) {
        return await axios.put(`order/${orderId}/items/${id}`, item)
    },

    async deleteOrderItem(orderId, id) {
        return await axios.delete(`order/${orderId}/items/${id}`)
    },

    async fetchOrderAssetRentalItems(orderId) {
        return await axios.get(`order/${orderId}/asset_rentals`)
    },

    // creates a whole order from an order definition
    // this is used by the
    async uploadOrder(order) {
        return await axios.post(`order/order_upload`, order)
    },

    /* Checkoff */
    async createCheckoff(orderId, data) {
        return await axios.post(`order/${orderId}/checkoff`, data)
    },

    async updateCheckoff(orderId, checkoffId, data) {
        return await axios.put(`order/${orderId}/checkoff/${checkoffId}`, data)
    },

    async deleteCheckoff(orderId, checkoffId) {
        return await axios.delete(`order/${orderId}/checkoff/${checkoffId}`)
    },

    /* checkoff Attachment */
    async deleteCheckoffAttachment(orderId, checkoffId, attachmentId) {
        const path = `order/${orderId}/checkoff/${checkoffId}/attachment/${attachmentId}`
        return await axios.delete(path)
    },
    async addCheckoffAttachment(orderId, checkoffId, url, name, file_extension) {
        const path = `order/${orderId}/checkoff/${checkoffId}/attachment`
        console.log('path', path)
        return await axios.post(path, { url, name, file_extension })
    },

    async renameCheckoffAttachment(id, name) {
        const path = `order/rename/checkoff-attachment/${id}`
        console.log('path', path)
        return await axios.put(path, { name })
    },

    /* Notes */
    async createNote(orderId, content) {
        return await axios.post(`order/${orderId}/note`, { content })
    },

    async deleteNote(orderId, noteId) {
        return await axios.delete(`order/${orderId}/note/${noteId}`)
    },

    /* Attachment */
    async deleteAttachment(orderId, attachmentId) {
        return await axios.delete(`order/${orderId}/attachment/${attachmentId}`)
    },
    async addAttachment(attachment) {
        const { order_id, long, lat, url, name,file_extension } = attachment
        let path = `order/${order_id}/attachment`
        return await axios.post(path, { long, lat, url, name,file_extension })
    },

    /* Bulk Actions */

    ///////////////////////////////
    async bulkSetDriver(orders, driverId,secondary_officer) {
        return await axios.post(`order/bulk_set_driver`, {
            driverId: driverId,
            orders: orders.map(x => x.id),
            secondary_officer : secondary_officer
        })
    },
    async bulkRelease(orders) {
        return await axios.post(`order/bulk_release`, {
            orders,
        })
    },
    async bulkCheckoff(orders) {
        console.log("orders", orders.bulkcheckoff)
        return await axios.post(`order/items/bulk_checkoff`, {
            order_id: orders.id,
            orderItems: orders.bulkcheckoff
        })
    },
    async bulkSetWarehouse(orders, warehouseId) {
        return await axios.post(`order/bulk_set_warehouse`, {
            warehouseId: warehouseId,
            orders: orders.map(x => x.id),
        })
    },
    async bulkSetIncomplete(payload) {
        return await axios.post(`order/bulk_set_incomplete`, payload)
    },
    async bulkSetcomplete(payload) {
        return await axios.post(`order/bulk_set_complete`, payload)
    },
    async bulkDelete(orders) {
        return await axios.post(`order/bulk_delete`, {
            orders: orders.map(x => x.id),
        })
    },

    ///template
    async createTemplate(orderId, template) {
        return await axios.post(`order/${orderId}/create_template`, template)
    },
    async fetchAuditLogs(orderId) {
        return await axios.get(`order/${orderId}/audit_logs`)
    },

    async fetchAttachments(orderId) {
        return await axios.get(`order/${orderId}/attachments`)
    },

    async fetchNotes(orderId) {
        return await axios.get(`order/${orderId}/notes`)
    },

    async fetchCheckoffs(orderId) {
        return await axios.get(`order/${orderId}/checkoffs`)
    },

    async fetchReceivedBy(orderId) {
        return await axios.get(`order/${orderId}/received_by`)
    },
    async bulkStatement(orderId,option){
        return await axios.post(`order/bulk_order_statement`,{
            
                orderId: orderId,
                option : option
            },{
            responseType: 'blob'
        })
    },
    async bulkStatementWithoutItem(orderId,option){
        return await axios.post(`order/bulk_order_statement_without_unused_item`,{
            
                orderId: orderId,
                option : option
            },{
            responseType: 'blob'
        })
    },

    async generateReceipt(orderId){
        return await axios.post(`order/generate_receipt`,{
            
                orderId: orderId,
            
            },{
            responseType: 'blob'
        })
    },
}
